import http from '@http';

class AdminClientRequestService {
    constructor() {
        if (AdminClientRequestService.instance) {
            return AdminClientRequestService.instance;
        }

        AdminClientRequestService.instance = this;
    }

    getClientRequests(queryObj) {
        return http.get('/api/admin/client-requests', {params: queryObj}).then(res => res.data);
    }

    getClientRequest(id) {
        return http.get(`/api/admin/client-requests/${id}`).then(res => res.data);
    }

    addClientRequest(data) {
        return http.post('/api/admin/client-requests', data).then(res => res.data);
    }

    updateClientRequest(id, data) {
        return http.put(`/api/admin/client-requests/${id}`, data).then(res => res.data);
    }

    updateStatus(id, data) {
        return http.put(`/api/admin/client-requests/${id}/status`, data).then(res => res.data);
    }

    deleteClientRequest(id) {
        return http.delete(`/api/admin/client-requests/${id}`).then(res => res.data);
    }

    addClient(id, data) {
        return http.post(`/api/admin/client-requests/${id}/clients`, data).then(res => res.data);
    }

    updateClient(id, clientId, data) {
        return http.put(`/api/admin/client-requests/${id}/clients/${clientId}`, data).then(res => res.data);
    }

    deleteClient(id, clientId) {
        return http.delete(`/api/admin/client-requests/${id}/clients/${clientId}`).then(res => res.data);
    }

    addComment(id, data) {
        return http.post(`/api/admin/client-requests/${id}/comments`, data).then(res => res.data);
    }

    deleteComment(id, commentId) {
        return http.delete(`/api/admin/client-requests/${id}/comments/${commentId}`).then(res => res.data);
    }

    getOptions() {
        return http.get('/api/admin/client-requests/options').then(res => res.data);
    }

    importCsv(formData) {
        return http.post('/api/admin/client-requests/import', formData, {
            headers: {'Content-Type': 'multipart/form-data'}
        }).then(res => res.data);
    }

    uploadFile(id, formData) {
        return http.post(`/api/admin/client-requests/${id}/files`, formData, {
            headers: {'Content-Type': 'multipart/form-data'}
        }).then(res => res.data);
    }

    deleteFile(id, fileId) {
        return http.delete(`/api/admin/client-requests/${id}/files/${fileId}`).then(res => res.data);
    }
}

export default new AdminClientRequestService();
